<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 15:15:42
 * @LastEditTime: 2020-06-20 17:06:15
 * @Description: 多项选或不定项选择作答区
-->
<template>
  <div class="multiple-choice">
    <div
      v-for="(option, index) in options"
      :key="option.id"
      class="multiple-choice-item-wrapper">
      <div
        class="multiple-choice-item"
        :class="answers.includes(option.id) ? 'active' : ''"
        @click="clickOption(option)">
        <span>
          <span class="prefix">{{ optionsEnum[index] }}</span>
          <span
            v-if="computeOptionType(option) === 'text'
            || computeOptionType(option) === 'hybrid'"
            >{{ option.content }}</span>
          <template v-if="computeOptionType(option) === 'media'">
            <video-player
              v-if="computeMediaType(option) === 'mp4'"
              :media-path="option.mediaInfoVO.mediaPath"
              :video-cover="option.mediaInfoVO.videoCover" />
            <audio-player
              v-if="computeMediaType(option) === 'mp3'"
              :media-path="option.mediaInfoVO.mediaPath" />
            <image-player
              v-if="computeMediaType(option) === 'jpg'"
              :media-path="option.mediaInfoVO.mediaPath" />
            <div
              v-else-if="computeMediaType(option) === 'pdf'"
              class="look-media"
              @click.stop="lookMedia(
                option.mediaPath,
                option.mediaInfoVO.mediaPath,
                option.mediaInfoVO.videoCover
              )">查看pdf多媒体文件</div>
          </template>
        </span>
        <img class="suffix" src="../../../../../assets/image/checked.png" />

        <div
          v-if="computeOptionType(option) === 'hybrid'"
          class="look-media"
          @click.stop="lookMedia(
          option.mediaPath,
          option.mediaInfoVO.mediaPath,
          option.mediaInfoVO.videoCover
          )">查看多媒体</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from '../../../../../utils';
import VideoPlayer from './VideoPlayer.vue';
import AudioPlayer from './AudioPlayer.vue';
import ImagePlayer from './ImagePlayer.vue';

const optionsEnum = ['A', 'B', 'C', 'D', 'E', 'F'];

export default {
  name: 'MultipleChoice',
  components: {
    VideoPlayer,
    AudioPlayer,
    ImagePlayer,
  },
  props: {
    type: { type: String, required: true },
    index: { type: Number, required: true },
    timeRemaining: { type: String, required: true },
  },
  data() {
    return {
      optionsEnum,
      answers: [],
    };
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'onlineExamStore/libraryInfo',
    }),
    question() {
      return this.libraryInfo[this.index];
    },
    options() {
      return this.question.libraryVo.options;
    },
  },
  watch: {
    question: {
      immediate: true,
      handler(question) {
        if (question.answer) {
          this.answers = question.answer.split(']');
        } else {
          this.answers = [];
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setLibraryInfo: 'onlineExamStore/invokeSetLibraryInfo',
    }),
    clickOption({ id }) {
      if (this.answers.includes(id)) {
        this.answers.splice(this.answers.indexOf(id), 1);
      } else {
        this.answers.push(id);
      }

      this.requestSaveAnswerAndSetting();
    },
    lookPdfMedia(mediaPath) {
      window.open(mediaPath, '_blank');
    },
    lookMedia(mediaPath, realMediaPath, videoCover) {
      this.$emit('preview-media', { mediaPath, realMediaPath, videoCover });
    },
    /**
     * 计算选项类型 -> 纯文本(text)/纯多媒体(media)/混合(hybrid)
     */
    computeOptionType(option) {
      if (option.content && option.mediaPath) {
        return 'hybrid';
      }

      if (option.content) {
        return 'text';
      }

      if (option.mediaPath) {
        return 'media';
      }

      return '';
    },
    computeMediaType({ mediaPath }) {
      const jpgReg = /jpg/;
      const pdfReg = /pdf/;
      const mp4Reg = /mp4/;
      const mp3Reg = /mp3/;

      if (jpgReg.test(mediaPath)) {
        return 'jpg';
      }

      if (mp4Reg.test(mediaPath)) {
        return 'mp4';
      }

      if (mp3Reg.test(mediaPath)) {
        return 'mp3';
      }

      if (pdfReg.test(mediaPath)) {
        return 'pdf';
      }

      return '';
    },
    /**
     * 多项或不定项选择发生改变时
     */
    async multipleChoiceSelectChanged(answers) {
      this.answers = answers;
      this.requestSaveAnswerAndSetting();
    },
    /**
     * 请求保存答题信息并设置
     */
    requestSaveAnswerAndSetting: debounce(function () {
      this.requestSaveAnswer()
        .then(() => {
          const libraryInfo = JSON.parse(JSON.stringify(this.libraryInfo));

          libraryInfo[this.index].answer = this.answers.join(']');

          this.setLibraryInfo({ libraryInfo });
        })
        .catch((result) => {
          alert(result.msg);

          if (result.msg === '您已在另一终端进入考试') {
            window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
          }
        });
    }, 500),
    /**
     *  请求保存答题信息
     */
    requestSaveAnswer() {
      const params = {
        id: this.question.id,
        answer: this.answers.join(']'),
        remainingTime: this.timeRemaining,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.answer.saveAnswer(params);
        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.multiple-choice {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 12px;
  width: 100%;

  .multiple-choice-item-wrapper {
    flex: 0 0 calc(50% - 40px);
    margin-right: 40px;
    margin-bottom: 20px;
  }

  &-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 0 0 50%;
    width: 80%;
    max-width: 460px;
    margin-bottom: 12px;
    padding: 8px 12px;
    background-color: #F1F1F1;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;

    .look-media {
      display: inline-block;
      color: #0C8CCA;
      font-size: 12px;
      cursor: pointer;
      padding: 4px 8px;
      background-color: rgba(12, 140, 202, .1);
      border-radius: 6px;
    }

    &.active {
      background-color: rgba(12, 140, 202, 0.08);
      color: #0C8CCA;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 1.2px solid #0C8CCA;
        border-radius: 4px;
      }

      > .suffix {
        display: block;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    > span:first-of-type {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .prefix {
      margin-right: 12px;
      font-weight: bold;
    }

    > .suffix {
      margin-left: 12px;
      width: 14px;
      height: 14px;
      display: none;
    }

    > .look-media {
      position: absolute;
      right: -12px;
      top: 50%;
      z-index: 300;
      transform: translateX(100%) translateY(-50%);
      color: #0C8CCA;
      font-size: 12px;
      cursor: pointer;
      padding: 4px 8px;
      background-color: rgba(12, 140, 202, .1);
      border-radius: 6px;
    }
  }

  // /deep/ .ivu-checkbox-group {
  //   display: flex;
  //   flex-direction: column;

  //   > .ivu-checkbox-group-item {
  //     display: flex;
  //     align-items: center;
  //     height: 30px;
  //     font-size: 12px;

  //     > .ivu-checkbox {
  //       margin-right: 8px;

  //       &.ivu-checkbox-disabled + span {
  //         color: @font-primary-color;
  //       }
  //     }
  //   }
  // }
}
</style>
